export default "__VITE_PUBLIC_ASSET__60ea2acc__"